// extracted by mini-css-extract-plugin
export default {"svgAnimation":"XkWSs10qGGYQbaZdw5Eb","svgSuccess":"O4M_tjctlI6M2y_ucdvZ","ok":"JzBPMLu9xUVV081FhFul"};